export default __webpack_public_path__ + "static/media/VectorDb.6af95e5a.svg";